var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirdrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 40,
    viewBox: "0 0 121 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.46 11.72L25 26H27.5L28.8 22.42H34.78L36.08 26H38.58L33.12 11.72H30.46ZM29.5 20.5L31.76 14.24H31.84L34.08 20.5H29.5ZM41.3142 11.44C40.8742 11.44 40.5142 11.58 40.2142 11.86C39.9142 12.14 39.7742 12.5 39.7742 12.94C39.7742 13.38 39.9142 13.74 40.2142 14.04C40.5142 14.32 40.8742 14.46 41.3142 14.46C41.7542 14.46 42.1142 14.32 42.4142 14.04C42.7142 13.76 42.8742 13.38 42.8742 12.94C42.8742 12.5 42.7142 12.14 42.4342 11.86C42.1342 11.58 41.7542 11.44 41.3142 11.44ZM40.1742 15.66V26H42.4542V15.66H40.1742ZM50.162 15.38C49.522 15.38 48.982 15.56 48.522 15.94C48.142 16.22 47.822 16.62 47.542 17.14V15.66H45.282V26H47.542V20.52C47.542 19.64 47.802 18.94 48.362 18.4C48.842 17.92 49.382 17.7 49.982 17.7C50.462 17.7 50.942 17.76 51.462 17.92V15.64C51.102 15.46 50.662 15.38 50.162 15.38ZM60.1225 11.44V17.08C59.2625 15.94 58.2425 15.38 57.0425 15.38C55.5625 15.38 54.3825 15.92 53.5425 17C52.7425 18 52.3625 19.26 52.3625 20.78C52.3625 22.36 52.7625 23.66 53.5625 24.66C54.4225 25.74 55.6225 26.28 57.1625 26.28C58.5225 26.28 59.5625 25.82 60.2825 24.9V26H62.4025V11.44H60.1225ZM57.5825 17.22C58.3025 17.22 58.9225 17.52 59.4025 18.12C59.9225 18.76 60.2025 19.64 60.2025 20.74V20.9C60.2025 21.9 59.9825 22.74 59.5625 23.38C59.0825 24.08 58.3825 24.44 57.5025 24.44C56.4825 24.44 55.7425 24.08 55.2825 23.36C54.8825 22.76 54.7025 21.9 54.7025 20.78C54.7025 19.66 54.9025 18.82 55.3225 18.24C55.8025 17.56 56.5425 17.22 57.5825 17.22ZM69.6738 15.38C69.0338 15.38 68.4938 15.56 68.0338 15.94C67.6538 16.22 67.3338 16.62 67.0538 17.14V15.66H64.7938V26H67.0538V20.52C67.0538 19.64 67.3138 18.94 67.8738 18.4C68.3538 17.92 68.8938 17.7 69.4938 17.7C69.9738 17.7 70.4538 17.76 70.9738 17.92V15.64C70.6138 15.46 70.1738 15.38 69.6738 15.38ZM77.0742 15.38C75.4942 15.38 74.2342 15.88 73.2942 16.92C72.3342 17.94 71.8742 19.24 71.8742 20.84C71.8742 22.42 72.3342 23.72 73.2742 24.72C74.2342 25.76 75.4942 26.28 77.0742 26.28C78.6342 26.28 79.9142 25.76 80.8742 24.72C81.7942 23.72 82.2742 22.42 82.2742 20.84C82.2742 19.24 81.7942 17.94 80.8542 16.92C79.8942 15.88 78.6342 15.38 77.0742 15.38ZM77.0742 17.24C78.0142 17.24 78.7542 17.6 79.2742 18.36C79.7142 19 79.9542 19.84 79.9542 20.84C79.9542 21.82 79.7142 22.64 79.2742 23.3C78.7542 24.04 78.0142 24.42 77.0742 24.42C76.1142 24.42 75.3942 24.04 74.8742 23.3C74.4342 22.66 74.2142 21.84 74.2142 20.84C74.2142 19.84 74.4342 19 74.8742 18.36C75.3942 17.6 76.1142 17.24 77.0742 17.24ZM89.5064 15.38C88.1464 15.38 87.1064 15.84 86.3864 16.76V15.66H84.2664V29.96H86.5464V24.58C87.3864 25.7 88.4264 26.28 89.6264 26.28C91.1064 26.28 92.2864 25.74 93.1264 24.66C93.9064 23.66 94.3064 22.4 94.3064 20.88C94.3064 19.28 93.9064 18 93.1064 17C92.2264 15.92 91.0264 15.38 89.5064 15.38ZM89.1664 17.22C90.1664 17.22 90.9064 17.58 91.3864 18.3C91.7664 18.9 91.9664 19.76 91.9664 20.88C91.9664 22 91.7464 22.86 91.3264 23.46C90.8464 24.1 90.0864 24.44 89.0864 24.44C88.3464 24.44 87.7464 24.14 87.2664 23.54C86.7264 22.88 86.4664 22 86.4664 20.92V20.76C86.4664 19.72 86.6664 18.9 87.1064 18.28C87.5864 17.56 88.2664 17.22 89.1664 17.22Z",
    fill: "url(#paint0_linear_0_1)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 120,
    height: 36,
    rx: 18,
    stroke: "url(#paint1_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 15,
    y: 1.44,
    width: 89.3064,
    height: 38.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 30,
    y1: 13.5,
    x2: 96,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#C3FF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#1EBAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F94C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 8.49497e-7,
    y1: 18,
    x2: 121,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#BBFC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#3AC5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EA3980"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdrop);
export default __webpack_public_path__ + "static/media/airdrop.af164df917efcb5c9bfcee4ebe12fcd4.svg";
export { ForwardRef as ReactComponent };